<mat-dialog-content class="content-body">
    <div #termText>

    </div>
</mat-dialog-content>
<mat-dialog-actions class="footer">
    <div class="row w-100">
  <mat-checkbox class="col-md-9 checkbox-label" color="primary" [(ngModel)]="agree">
    I have read and agree to the Terms of Use.
  </mat-checkbox>
  
  <button
  class="col-md-3"
  [disabled]="!agree"
    [mat-dialog-close]="true"
  
  mat-flat-button
  color="primary"
>
   Continue
</button>
</div>
</mat-dialog-actions>
